<template>
  <div>
    <template v-if="mode == 'show'">
      <div class="py-1">
        <div class="text-xs font-bold">{{$t('form.email.label')}}</div>
        <div class="text-sm text-gray-500">{{user.email}}</div>
      </div>
      <div class="py-1" v-if="usesPassword">
        <div class="text-xs font-bold">{{$t('form.password.label')}}</div>
        <div class="text-sm text-gray-500">**********</div>
      </div>
    </template>

    <div v-if="mode == 'edit'" class="flex flex-col items-stretch">
      <text-input 
        v-model="newEmail"
        type="email"
        autocomplete="email"
      />  
      <div class="error mb-2 mt-1" v-if="emailError">
        {{$t(`error.${emailError}`)}}
      </div>
      <template v-if="usesPassword">
        <password-input
          v-model="newPassword"
          autocomplete="new-password"
          :placeholder="$t('form.new-password.placeholder')"
        />
        
        <div class="error mb-2 mt-1" v-if="passwordError">
          {{$t(`error.${passwordError}`)}}
        </div>
      </template>

      <div class="info mb-2 mt-1" v-if="emailInfo">
        {{$t(emailInfo)}}
      </div>
      <div class="flex my-1">
        <button class="flex-1 mr-1 btn btn-2" @click="cancel">
          {{$t('cancel')}}
        </button>
        <button class="flex-1 ml-1 btn btn-1" @click="save">
          {{$t('save')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PasswordInput from '@/components/PasswordInput.vue'
import TextInput from '@/components/TextInput.vue'


export default {
  data() {
    return {
      mode: 'show',
      oldPassword: '',
      newPassword: '',
      newEmail: '',
      emailError: '',
      passwordError: '',
    }
  },
  components: {
    TextInput,
    PasswordInput,
  },
  computed: {
    ...mapGetters(['user']),
    usesPassword() {
      return this.user.providerData.filter(pd => pd.providerId == 'password').length > 0
    },
    emailInfo() {
      if(this.user.email != this.newEmail) {
        return 'info.email-update'
      } else {
        return false
      }
    },
  },
  async mounted() {
    await this.$store.getters.authInit
    this.newEmail = this.user.email
  },
  methods: {
    edit() {
      this.mode = 'edit'
    },
    async save() {
      if(this.usesPassword && this.newPassword.length > 0) {
        try {
          await this.$store.dispatch('changePassword', this.newPassword)
          this.mode = 'show'
        } catch(e) {
          this.passwordError = e.code
        }
      }
      if(this.newEmail.length > 0 && this.newEmail != this.user.email) {
        try {
          await this.$store.dispatch('changeEmail', this.newEmail)
          if(this.user.emailVerified) {
            this.mode = 'show'
          } else {
            
            this.$router.push({name: 'EmailVerification'})
          }
        } catch(e) {
          this.emailError = e.code
        }
      }
    },
    cancel() {
      this.newEmail = this.user.email
      this.mode = 'show'
    }
  }
}
</script>

<style>

</style>